import { render, staticRenderFns } from "./userSendSMS.vue?vue&type=template&id=33b7846d&scoped=true&"
import script from "./userSendSMS.vue?vue&type=script&lang=js&"
export * from "./userSendSMS.vue?vue&type=script&lang=js&"
import style0 from "./userSendSMS.vue?vue&type=style&index=0&id=33b7846d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b7846d",
  null
  
)

component.options.__file = "userSendSMS.vue"
export default component.exports